import { useInputHasFocus } from '../../../hooks/input-has-focus.hook';
import { useMaxLengthCount } from '../../../hooks/max-length-count.hook';
import { HookFormRules } from '../hook-form.models';
import { MaxLengthDisplayBase } from './MaxLengthDisplayBase';

interface Props {
    name: string;
    errorName: string | undefined;
    rules?: HookFormRules;
}

export const MaxLengthDisplay = ({
    name,
    errorName,
    rules,
}: Props): React.ReactElement<any, any> | null => {
    const { length, greater, maxLength } = useMaxLengthCount(errorName || name, rules);

    const { hasFocus } = useInputHasFocus(errorName || name);

    return (
        <MaxLengthDisplayBase
            length={length}
            maxLength={maxLength}
            hasFocus={hasFocus}
            isGreater={greater}
        />
    );
};
